import type { JSX } from 'react';

import { ProjectAlertsConfigEditor } from 'features/projects';

interface CreateAlertsSectionProps {
  projectId: number;
}

const CreateAlertsSection = ({ projectId }: CreateAlertsSectionProps): JSX.Element => (
  <ProjectAlertsConfigEditor projectId={projectId} />
);

export default CreateAlertsSection;
